(() => {
  const container = document.getElementById('LocalizationRecommendation');
  const dataScript = document.getElementById('LocalizationRecommendationData');
  const form = document.getElementById('LocalizationRecommendationForm');

  if (!container || !dataScript || !form || !window.Shopify || window.Shopify.designMode) return;

  const storageKey = 'bangproof.localizationRecommendation.dismissedUntil';
  const dismissalDuration = 14 * 24 * 60 * 60 * 1000;

  const parseData = () => {
    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      return null;
    }
  };

  const getDismissedUntil = () => {
    try {
      return Number(window.localStorage.getItem(storageKey) || 0);
    } catch (error) {
      return 0;
    }
  };

  const dismiss = () => {
    try {
      window.localStorage.setItem(storageKey, String(Date.now() + dismissalDuration));
    } catch (error) {
      // If storage is blocked, still hide the prompt for the current page.
    }

    container.hidden = true;
  };

  const buildSuggestionsUrl = (currentCountry, currentLanguage) => {
    const root = window.Shopify.routes?.root || '/';
    const params = new URLSearchParams({
      'country[enabled]': 'true',
      'language[enabled]': 'true',
    });

    if (currentCountry) params.set('country[exclude]', currentCountry);
    if (currentLanguage) params.set('language[exclude]', currentLanguage);

    return `${root}browsing_context_suggestions.json?${params.toString()}`;
  };

  const getRecommendedLocalization = (response, data, currentCountry, currentLanguage) => {
    const suggestion = response?.suggestions?.[0];
    const countryHandle = suggestion?.parts?.country?.handle;
    const languageHandle = suggestion?.parts?.language?.handle;

    const recommendedCountry =
      countryHandle && countryHandle !== currentCountry && data.countries[countryHandle] ? countryHandle : null;
    const recommendedLanguage =
      languageHandle && languageHandle !== currentLanguage && data.languages[languageHandle] ? languageHandle : null;

    if (!recommendedCountry && !recommendedLanguage) return null;

    return {
      country: recommendedCountry,
      language: recommendedLanguage,
    };
  };

  const countryCodeToFlag = (countryCode) => {
    if (!countryCode || countryCode.length !== 2) return '';

    return countryCode
      .toUpperCase()
      .split('')
      .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
      .join('');
  };

  const isLocalThemeDev = () => window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';

  const getReturnPath = () => {
    const path = `${window.location.pathname}${window.location.search}`;

    if (!isLocalThemeDev() || !window.Shopify?.theme?.id) return path;

    const returnUrl = new URL(path, window.location.origin);
    returnUrl.searchParams.set('preview_theme_id', window.Shopify.theme.id);

    return `${returnUrl.pathname}${returnUrl.search}`;
  };

  const showPrompt = (recommendation, data) => {
    const country = recommendation.country ? data.countries[recommendation.country] : null;
    const language = recommendation.language ? data.languages[recommendation.language] : null;
    const countryName = country?.name || 'your region';
    const currencyLabel = country ? `${country.currencyCode} ${country.currencySymbol}` : '';
    const messageParts = [];

    if (country) {
      messageParts.push(`We detected that ${countryName} may be a better match for your location.`);
      messageParts.push(`Switch to see local pricing${currencyLabel ? ` in ${currencyLabel}` : ''}.`);
    }

    if (language) {
      messageParts.push(`We can also switch your language to ${language.name}.`);
    }

    container.querySelector('[data-localization-country-name]').textContent = countryName;
    container.querySelector('[data-localization-flag]').textContent = countryCodeToFlag(recommendation.country);
    container.querySelector('[data-localization-message]').textContent = messageParts.join(' ');

    container.hidden = false;
    container.querySelector('[data-localization-accept]')?.focus();
  };

  const submitRecommendation = (recommendation, data) => {
    const countryInput = form.querySelector('input[name="country_code"]');
    const languageInput = form.querySelector('input[name="locale_code"]');
    const languageCodeInput = form.querySelector('input[name="language_code"]');
    const methodInput = form.querySelector('input[name="_method"]') || document.createElement('input');
    const returnInput = form.querySelector('input[name="return_to"]') || document.createElement('input');

    if (countryInput && recommendation.country) countryInput.value = recommendation.country;
    if (languageInput && recommendation.language) languageInput.value = recommendation.language;
    if (languageCodeInput && recommendation.language) languageCodeInput.value = recommendation.language;

    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'PUT';
    if (!methodInput.parentElement) form.appendChild(methodInput);

    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value = getReturnPath();
    if (!returnInput.parentElement) form.appendChild(returnInput);

    if (isLocalThemeDev() && window.Shopify.shop) {
      form.action = `https://${window.Shopify.shop}/localization`;
    }

    try {
      window.localStorage.setItem(storageKey, String(Date.now() + dismissalDuration));
    } catch (error) {
      // The localization form submission still works without localStorage.
    }

    form.submit();
  };

  const init = async () => {
    if (getDismissedUntil() > Date.now()) return;

    const data = parseData();
    if (!data) return;

    const currentCountry = window.Shopify.country || data.currentCountry;
    const currentLanguage = window.Shopify.language || window.Shopify.locale || data.currentLanguage;

    try {
      const response = await fetch(buildSuggestionsUrl(currentCountry, currentLanguage), {
        credentials: 'same-origin',
      }).then((result) => (result.ok ? result.json() : null));

      const recommendation = getRecommendedLocalization(response, data, currentCountry, currentLanguage);
      if (!recommendation) return;

      container.querySelectorAll('[data-localization-dismiss]').forEach((button) => {
        button.addEventListener('click', dismiss);
      });

      container.querySelector('[data-localization-accept]')?.addEventListener('click', () => {
        submitRecommendation(recommendation, data);
      });

      document.addEventListener('keydown', (event) => {
        if (!container.hidden && event.key === 'Escape') dismiss();
      });

      showPrompt(recommendation, data);
    } catch (error) {
      // Fail silently so localization never blocks storefront browsing.
    }
  };

  init();
})();
